import React from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';

const inputStyles = {
  bg: '#202225',
  borderColor: 'gray.600',
  _hover: { borderColor: 'gray.500' },
  _focus: { borderColor: 'yellow.400', boxShadow: '0 0 0 1px #ECC94B' },
};

const FIELDS = [
  { key: 'phone', label: 'Telefono', placeholder: '+39 333 1234567' },
  { key: 'website', label: 'Sito web', placeholder: 'https://www.miosito.it' },
  { key: 'instagram', label: 'Instagram', placeholder: '@username o URL' },
  { key: 'facebook', label: 'Facebook', placeholder: 'Pagina o profilo' },
  { key: 'tiktok', label: 'TikTok', placeholder: '@username' },
  { key: 'twitch', label: 'Twitch', placeholder: 'canale Twitch' },
  { key: 'discord', label: 'Discord', placeholder: 'username o invito' },
];

const SocialSection = ({ currentDraft, onDraftChange }) => (
  <>
    <Text fontSize="sm" color="gray.400" mb={4}>
      Tutti i campi sono facoltativi. Compila solo quelli che vuoi mostrare.
    </Text>
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
      {FIELDS.map(({ key, label, placeholder }) => (
        <FormControl key={key}>
          <FormLabel fontSize="sm">{label}</FormLabel>
          <Input
            value={currentDraft?.[key] || ''}
            onChange={(e) => onDraftChange(key, e.target.value)}
            placeholder={placeholder}
            size={{ base: 'md', md: 'md' }}
            {...inputStyles}
          />
        </FormControl>
      ))}
    </SimpleGrid>
  </>
);

export default SocialSection;
